/**
 * AIMÉ – dezente Einblend-Effekte für [data-aime-reveal]-Container.
 * Ohne Library. Bei "Bewegung reduzieren", ohne IntersectionObserver oder im Theme Editor
 * wird alles sofort sichtbar gemacht.
 */
(function () {
  'use strict';

  var SELECTOR = '.aime-reveal';

  function showAll(root) {
    var items = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < items.length; i++) items[i].classList.add('is-revealed');
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
    showAll();
    document.addEventListener('shopify:section:load', function (e) { showAll(e.target); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function observe(root) {
    var items = (root || document).querySelectorAll(SELECTOR + ':not(.is-revealed)');
    for (var i = 0; i < items.length; i++) observer.observe(items[i]);
  }

  observe();
})();
